export default __webpack_public_path__ + "static/media/project-1.81db8d5f.jpg";